/**
 * 系统公告管理API - v2.0
 * 支持副标题、富文本内容、统计功能等新特性
 */
import request from '@/utils/request'

// ==================== 管理员公告管理接口 ====================

/**
 * 创建公告 
 * @param {Object} data - 公告数据
 * @returns {Promise}
 */
export function createAnnouncement(data) {
  return request({
    url: '/system/announcements',
    method: 'post',
    data
  })
}

/**
 * 获取公告列表
 * @param {Object} params - 查询参数
 * @returns {Promise}
 */
export function getAnnouncements(params = {}) {
  return request({
    url: '/system/announcements',
    method: 'get',
    params
  })
}

/**
 * 获取公告详情
 * @param {number} announcementId - 公告ID
 * @returns {Promise}
 */
export function getAnnouncement(announcementId) {
  return request({
    url: `/system/announcements/${announcementId}`,
    method: 'get'
  })
}

/**
 * 更新公告信息
 * @param {number} announcementId - 公告ID
 * @param {Object} data - 更新数据
 * @returns {Promise}
 */
export function updateAnnouncement(announcementId, data) {
  return request({
    url: `/system/announcements/${announcementId}`,
    method: 'put',
    data
  })
}

/**
 * 删除公告
 * @param {number} announcementId - 公告ID
 * @returns {Promise}
 */
export function deleteAnnouncement(announcementId) {
  return request({
    url: `/system/announcements/${announcementId}`,
    method: 'delete'
  })
}

/**
 * 更新公告状态
 * @param {number} announcementId - 公告ID
 * @param {boolean} isActive - 是否启用
 * @returns {Promise}
 */
export function updateAnnouncementStatus(announcementId, isActive) {
  return request({
    url: `/system/announcements/${announcementId}/status`,
    method: 'put',
    data: {
      is_active: isActive
    }
  })
}

/**
 * 获取公告统计信息 🆕
 * @param {number} announcementId - 公告ID
 * @returns {Promise}
 */
export function getAnnouncementStatistics(announcementId) {
  return request({
    url: `/system/announcements/${announcementId}/statistics`,
    method: 'get'
  })
}

// ==================== 用户端展示接口 🆕 ====================

/**
 * 获取用户端公告列表
 * @param {Object} params - 查询参数
 * @returns {Promise}
 */
export function getAppAnnouncements(params = {}) {
  return request({
    url: '/system/app/announcements',
    method: 'get',
    params
  })
}

/**
 * 获取弹窗公告
 * @returns {Promise}
 */
export function getPopupAnnouncements() {
  return request({
    url: '/system/app/popup-announcements',
    method: 'get'
  })
}

/**
 * 获取用户端公告详情
 * @param {number} announcementId - 公告ID
 * @returns {Promise}
 */
export function getAppAnnouncementDetail(announcementId) {
  return request({
    url: `/system/app/announcements/${announcementId}`,
    method: 'get'
  })
}

/**
 * 记录公告查看
 * @param {number} announcementId - 公告ID
 * @returns {Promise}
 */
export function recordAnnouncementView(announcementId) {
  return request({
    url: `/system/app/announcements/${announcementId}/view`,
    method: 'post'
  })
}

/**
 * 标记公告已读
 * @param {number} announcementId - 公告ID
 * @returns {Promise}
 */
export function markAnnouncementRead(announcementId) {
  return request({
    url: `/system/app/announcements/${announcementId}/read`,
    method: 'post'
  })
}

// ==================== 已废弃的API (保留兼容性) ====================

/**
 * @deprecated 已废弃：批量删除功能暂时不支持
 */
export function deleteAnnouncements(announcementIds) {
  console.warn('deleteAnnouncements 暂时不支持')
  return Promise.reject(new Error('批量删除功能暂时不支持'))
}

/**
 * @deprecated 已废弃：发布/撤销逻辑已简化为状态管理
 * 使用 updateAnnouncementStatus 替代
 */
export function publishAnnouncement(announcementId) {
  console.warn('publishAnnouncement 已废弃，请使用 updateAnnouncementStatus')
  return updateAnnouncementStatus(announcementId, true)
}

/**
 * @deprecated 已废弃：发布/撤销逻辑已简化为状态管理
 * 使用 updateAnnouncementStatus 替代
 */
export function withdrawAnnouncement(announcementId) {
  console.warn('withdrawAnnouncement 已废弃，请使用 updateAnnouncementStatus')
  return updateAnnouncementStatus(announcementId, false)
}

/**
 * @deprecated 已废弃：统计功能已重构
 * 使用 getAnnouncementStatistics 替代
 */
export function getAnnouncementStats(announcementId) {
  console.warn('getAnnouncementStats 已废弃，请使用 getAnnouncementStatistics')
  return getAnnouncementStatistics(announcementId)
} 